export default class Garage {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.garage-view');
        this.mappings = HONDA?.MyAccount2AccessoryMapping;
        this.fetchModelsList = `${this.mappings.basePath}/jcr:content/accCatalog.models.range_default.JSON`; // to test locally remove jsr:content and point to stubs this.filePrefix = '/accCatalog.models.range_default.JSON';
        this.fetchGroupsPrefix = 'jcr:content/accCatalog.groups.range_default.model_'; // to test locally remove jsr:content and point to stubs this.filePrefix = '/accCatalog.groups.range_default.model_';

        /* templates */
        this.accessoriesGroupsTemplate = _.template(
            parent.el.querySelector('#accessories-groups').innerHTML.replaceAll('\\', ''),
        );

        this.bind();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.populate());
    }

    async populate() {
        if(!this.orders) {
            this.orders = await window.HONDA.MyAccount2.client.getOrders();
        }
        if(!this.modelsRangeList) {
            this.modelsRangeList = await window.HONDA.MyAccount2.client.getAccessoryModels(this.fetchModelsList);
        }

        const uniqueSavedCars = new Set();
        const stateList = ['Order Cancelled', 'Cancellation Pending'];
        const {orderStatus} = this.orders.length > 0 ? this.orders[0] : {};
        if (!stateList.includes(orderStatus)) {
            this.orders?.map((order) => uniqueSavedCars.add(this.mappings.modelCodes[order.summary?.ids?.modelCode]));
        }
        HONDA?.SaveForLater?.saveForLater?.saved?.map((item) => uniqueSavedCars.add(this.mappings.modelCodes[item.data.model]));

        this.setupAccessories(uniqueSavedCars);
    }

    async setupAccessories(uniqueSavedCars) {
        if (uniqueSavedCars) {
            const promises = uniqueSavedCars.filter((car)=> car).map((mappedAccessory) => this.renderAccessoriesCarModels(mappedAccessory));
            const results = await Promise.all(promises);
            this.el.querySelector('.acc-group-items').innerHTML =  results.filter((res)=> res).join('');
        }
    }

    async renderAccessoriesCarModels(mappedAccessory) {
        const groups = await this.fetchAccessoriesGroups(mappedAccessory);
        const model = this.modelsRangeList?.find(el => el.id === mappedAccessory)

        if (model && groups) {
            const accessoriesGroupsTemplate = `<p class="card--subHeading">${model?.title}</p> <div class="accessories-link-container">${groups}</div>`;
            return accessoriesGroupsTemplate;
        }
    }

    async fetchAccessoriesGroups(mappedAccessory) {

        if (!this.mappings.basePath || !this.fetchGroupsPrefix || !mappedAccessory) {
            return false;
        }

        const requestURL = `${this.mappings.basePath}/${this.fetchGroupsPrefix}${mappedAccessory}.JSON`;

        try {
            const data = await window.HONDA.MyAccount2.client.getAccessoryGroups(requestURL, mappedAccessory);

            const groups = this.accessoriesGroupsTemplate({
                data,
                mappedAccessory,
            });

            return groups;
        } catch (e) {
            return false;
        }
    }
}
